var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 6.91138L12 2.41138L3.00004 6.91138V8.4999H21L21 6.91138ZM12 4.08843L17.823 6.9999H6.17709L12 4.08843ZM19.5 9.9999V17.9999H18V9.9999H19.5ZM6 9.99993V17.9999H4.5V9.99993H6ZM3 20.9999H21V19.4999H3V20.9999Z",
    fill: "#0A3575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.101 11.0881C9.20942 11.4161 8.77082 12.5641 9.12002 13.6527C9.46982 14.7407 12 17 12 17C12 17 14.5302 14.7407 14.88 13.6527C15.2292 12.5641 14.7906 11.4161 13.899 11.0881C13.518 10.9478 13.1159 10.9803 12.7531 11.1486C12.4681 11.2808 12.2073 11.4969 12 11.7788C11.7927 11.4969 11.5319 11.2808 11.2469 11.1486C10.8841 10.9803 10.482 10.9478 10.101 11.0881Z",
    fill: "#0A3575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharity);
export default __webpack_public_path__ + "static/media/charity.87e1d051c5aae12fe686a19356c56da1.svg";
export { ForwardRef as ReactComponent };